import { CONTENT_PRESET_COLORS, WHITE } from '../appearance/Colors';

export { CONTENT_PRESET_COLORS };

export const getContentPresetColor = (kind, id, fallback = WHITE) =>
    CONTENT_PRESET_COLORS[kind]?.[id] || fallback;
